import AmexGDAB2B, { ComponentAmexGDAB2BUnderTest } from './AmexGDAB2B';

export default AmexGDAB2B;

export {
  ComponentAmexGDAB2BUnderTest,
};
